module.exports = __webpack_public_path__ + "static/Pre build solutions-be8296abf47d70f2759baf9e0aef558c.png";